import cn from 'clsx'

// Types
import { CmsPage } from 'types'

// Components
import { Link } from '@tracklib/kit'

// Utils
import { youtubeRegex } from 'components/articles/hero/hero'
import formatDate from 'lib/formatdate'

import styles from './intro.css'

type IntroProps = {
  article: CmsPage
}

const Intro = ({ article }: IntroProps) => {
  if (!article) {
    return null
  }
  const { title, video, introduction, author, meta } = article

  const date = meta.first_published_at
  const centered = title?.toLowerCase().includes('state of sampling')

  const hasVideo = video && video?.match(youtubeRegex)?.[1]
  return (
    <div className={cn(styles.container, centered && styles.centered)}>
      {hasVideo && <h1 className={styles.title}>{title}</h1>}
      {introduction && <p className={styles.introduction}>{introduction}</p>}
      <span className={styles.time}>
        {author && (
          <span>
            By{' '}
            <Link to={`/user/${author.id}/`}>
              <span>{author.alias}</span>
            </Link>{' '}
            <em>•</em>
          </span>
        )}{' '}
        <time dateTime={date}>{formatDate(date)}</time>
      </span>
    </div>
  )
}

export default Intro
